// import  { Dashboard }   from "@mydex/dashboards";
/**
 * Table
 */
export const Table = (function () {

  var init =  function () {   
      // Import & Add to window context the Dashboards because it is used by Tables
      window.Dashboard = Dashboard;
      Dashboard.load();

      $('.myds-btn-table').on('click', (e) => {
        e.preventDefault();
        var value = $(e.currentTarget).data('value');
        var field = $(e.currentTarget).data('field');
        
        Dashboard.table.filterBy(field, value);
      });

      $('#btnAll').on('click', (e) => {
        e.preventDefault();
        Dashboard.table.filterBy();
      });
  }

  var getViewport = function(percentage) {
    let vh  = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    return Math.max( (vh / 100) * percentage);
  }

  return {
    init: init,
    getViewport : getViewport
  }

}());


